import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// Legacy WordPress page — permanently redirect to non-surgical solutions.
export const Route = createFileRoute("/ever-hair")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/non-surgical/", location.searchStr), statusCode: 301 });
  },
});
